
import React from "react";
import { useAppSelector } from "../../../app/hooks";
import Loading from "../../../components/Loading/Loading";
import { accountSelected } from "../../students/slice/studentSlice";
import { Student } from "../../students/types/types";
import {
  useGetProfileChartQuery
} from "../api/profileChartsApi";
import ProfileChartsPresentation from "../presentation/ProfileChartsPresentation";
type ProfileChartsContainerProps = {
  student: Student;
};
const ProfileChartsContainer: React.FC<ProfileChartsContainerProps> = ({
  student
}) => {
  const account = useAppSelector(accountSelected)
  const {
    data: chartsData,
    isLoading,
    isError,
    isSuccess,
    error
  } = useGetProfileChartQuery({
    currentSystem: JSON.stringify(account),
    studentId: student._id.toString()
  })

  let content
  if (isLoading) {
    content = <Loading />
  } else if (isSuccess) {
    content = <ProfileChartsPresentation chartData={chartsData} />
  } else if (isError) {
    console.error(error)
    content = <p>Please make sure you set dates in setting</p>
  }
  return <>{content}</>
}

export default ProfileChartsContainer
